import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {finalize} from 'rxjs/operators';

import {GetSaseungTxt} from 'src/app/shared/defines/gukeo.func';
import {Saseung3} from "../../shared/models/saseung3.model";
import {Saseung3BookmarkService} from '../../shared/services/saseung3/saseung3-bookmark.service';


@Component({
  selector: 'app-saseung3-item',
  templateUrl: './saseung3-item.component.html',
  styleUrls: ['./saseung3-item.component.scss']
})
export class Saseung3ItemComponent {
  @Input() saseung3?: Saseung3;
  @Input() showHangul: boolean = false;
  @Input() showBookmark: boolean = false;
  @Output() changeBookmark = new EventEmitter<boolean>();

  // #589: 우선순위 2(order1 === '2') 항목 마커. style.scss의 우선순위 구분선(:has) selector가 사용.
  @HostBinding('class.priority2')
  get isPriority2(): boolean {
    return this.saseung3?.order1 === '2';
  }

  private sendingBookmark = false;

  constructor(
    private bmSvc: Saseung3BookmarkService,
  ) {
  }

  /**
   * 사성 심볼(P/S/G/I/K/B)을 한글로 변환
   */
  public GetSaseungTxt(symbol: string): string {
    const saseungTxt = GetSaseungTxt(symbol);
    if (!saseungTxt) {
      console.error('Saseung3ItemComponent::GetSaseungTxt() invalid saseung symbol', symbol);
    }
    return saseungTxt ? saseungTxt : '';
  }

  /**
   * four_tones 문자열에서 각 사성을 배열로 분리
   * 예: "PG" -> ["P", "G"]
   */
  public getFourTonesArray(): string[] {
    if (!this.saseung3?.four_tones) {
      return [];
    }
    return this.saseung3.four_tones.split('');
  }

  /**
   * 훈을 파이프(|)로 분리한 배열
   */
  private get hunParts(): string[] {
    if (!this.saseung3?.meaning) return [];
    return this.saseung3.meaning.split('|');
  }

  /**
   * 훈에서 첫 번째 훈만 추출
   */
  get firstHun(): string {
    return this.hunParts[0] ?? '';
  }

  /**
   * 첫 번째를 제외한 나머지 훈 반환
   * 원본: 파이프(|)로 구분된 meaning 문자열 (hunParts 사용)
   * 출력: 중간점(' · ')으로 구분된 문자열
   */
  get restHun(): string {
    return this.hunParts.slice(1).join(' · ');
  }

  public ToggleBookmark(event: MouseEvent, saseung3: Saseung3): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;
    const prevBookmark = saseung3.bookmark;
    saseung3.bookmark = !saseung3.bookmark;
    this.bmSvc.sendBookmark(saseung3.id, saseung3.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe({
      next: () => {
        this.changeBookmark.emit(saseung3.bookmark);
      },
      error: (err) => {
        console.error('ToggleBookmark failed', saseung3.id, err);
        saseung3.bookmark = prevBookmark;
      }
    });
  }

  public getBmCss(saseung3: Saseung3): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return saseung3.bookmark ? 'on' : '';
  }
}
